<template>
  <div class="tabs-head">
    <div class="tabs-wrapper" :style="tabsWrapperStyle">
      <span v-show="showNavBar" @click="scrollPrev" class="tabs-nav tabs-nav-prev"><i class="el-icon-arrow-left"></i></span>
      <span v-show="showNavBar" @click="scrollNext" class="tabs-nav tabs-nav-next"><i class="el-icon-arrow-right"></i></span>
      <div ref="tabsScrollRef" class="tabs-scroll">
        <ul ref="navRef" class="tabs-head-ul" :style="navStyle">
          <li v-for="item in topTabList" class="tabs-li" @click="handleTopTabClick(item)" @click.prevent.right="handleTopTabRightClick(item, $event)">
            <a href="javascript:" class="tabs-link" v-bind:class="{'tabs-cur': item.id === currentPageId}">
              <span class="tabs-txt" :title="item.name">{{ item.name }}</span>
              <span class="tabs-shut"  @click.stop="closeTab(item)"><i class="mng icon-cross-stroke"></i></span>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div
      v-show="showTabMenu"
      :style="[{'left': tabMenuLeft + 'px'}, {'top': tabMenuTop + 'px'}]"
      class="drop top-tab-drop-menu">
      <ul>
        <li @click="closeCurrentTab" class="drop-list">
          <a href="javascript:" class="drop-link">
            <span class="drop-txt">关闭当前</span>
          </a>
        </li>
        <li @click="closeOtherTab" class="drop-list">
          <a href="javascript:" class="drop-link">
            <span class="drop-txt">关闭其它</span>
          </a>
        </li>
        <li @click="closeAllTab" class="drop-list">
          <a href="javascript:" class="drop-link">
            <span class="drop-txt">关闭所有</span>
          </a>
        </li>
        
        <li @click="refreshTab" v-show="isCurrentTab" class="drop-list">
          <a href="javascript:" class="drop-link">
            <span class="drop-txt">刷新</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  import {STORE_APP_MUTATION_TYPES} from '../../libs/constants'
  import { addResizeListener, removeResizeListener } from 'element-ui/src/utils/resize-event'
  import util from '../../libs/util'

  export default {
    name: 'top-tabs',
    data() {
      return {
        showTabMenu: false,
        tabMenuLeft: 0,
        isCurrentTab: false,
        tabMenuTop: 0,
        tabMenuOnTab: {}, // 当前tab子菜单出现的tab  id
        showNavBar: false, // 是否显示导航左右移动的按钮
        navOffset: 0 // 导航栏横向偏移量
      }
    },
    computed: {
      topTabList: function () {
        return this.$store.state.app.topTabList
      },
      currentPageId: function () {
        return this.$store.state.app.currentPageId
      },
      tabsWrapperStyle: function () {
        let styleObj = {}
        if (this.showNavBar) {
          styleObj['padding'] = '0 13px'
        }
        return styleObj
      },
      navStyle() {
        return {
          transform: `translateX(-${this.navOffset}px)`
        }
      }
    },
    mounted() {
      addResizeListener(this.$refs.navRef, this.update)
      addResizeListener(this.$refs.tabsScrollRef, this.update)
      util.detectBack(this)
    },
    methods: {
      getDestRouter(tab) {
        return util.getDestRouter(tab)
      },
      closeTab(tab) {
        this.$store.commit(STORE_APP_MUTATION_TYPES.REMOVE_TAB_BY_ID, tab)
        if (this.$store.state.app.currentPageId) {
          const dest = this.getDestRouter(this.$store.state.app.currentTab)
          this.$router.push(dest)
        } else {
          this.$router.push('/')
        }
      },
      handleTopTabClick(tab) {
        this.$store.commit(STORE_APP_MUTATION_TYPES.UPDATE_CURRENT_PAGE, tab)
        this.$store.commit(STORE_APP_MUTATION_TYPES.UPDATE_CURRENT_LEFT_MENU, {id: tab.id})
        const dest = this.getDestRouter(tab)
        this.$router.push(dest)
      },
      handleTopTabRightClick(tab, e) {
        this.tabMenuOnTab = tab
        this.showTabMenu = true
        this.tabMenuLeft = e.x
        this.tabMenuTop = e.y
        if (this.$store.state.app.currentPageId === tab.id) {
          this.isCurrentTab = true
        } else {
          this.isCurrentTab = false
        }
      },
      closeTopTabDropMenu() { // 关闭tab的下拉菜单
        this.showTabMenu = false
      },
      closeCurrentTab() {
        this.closeTab(this.tabMenuOnTab)
      },
      closeOtherTab() {
        this.$store.commit(STORE_APP_MUTATION_TYPES.CLOSE_OTHER_TABS, this.tabMenuOnTab)
      },
      closeAllTab() {
        this.$store.commit(STORE_APP_MUTATION_TYPES.CLOSE_ALL_TABS)
        this.$router.push('/')
      },
      refreshTab() {
        this.$store.commit(STORE_APP_MUTATION_TYPES.REMOVE_CACHED_VIEWS, this.tabMenuOnTab)
        this.$store.commit(STORE_APP_MUTATION_TYPES.UPDATE_CURRENT_PAGE, {id: '', routers: []})
        this.$router.push({name: 'loading'})
        this.$store.commit(STORE_APP_MUTATION_TYPES.UPDATE_CURRENT_PAGE, this.tabMenuOnTab)
        setTimeout(() => {
          // this.$router.push({name: this.tabMenuOnTab.id})
          const dest = this.getDestRouter(this.tabMenuOnTab)
          this.$router.push(dest)
          this.$store.commit(STORE_APP_MUTATION_TYPES.ADD_CACHED_VIEWS, this.tabMenuOnTab)
        }, 100)
      },
      update() {
        let currentOffset = this.navOffset
        let containerSize = this.$refs.tabsScrollRef['offsetWidth']
        let navSize = this.$refs.navRef['offsetWidth']
        if (containerSize < navSize) {
          this.showNavBar = true
          if (navSize - currentOffset < containerSize) {
            this.navOffset = navSize - containerSize
          }
        } else {
          this.showNavBar = false
          if (currentOffset > 0) {
            this.navOffset = 0
          }
        }
      },
      scrollPrev() {
        let containerSize = this.$refs.tabsScrollRef['offsetWidth']
        let currentOffset = this.navOffset

        if (!currentOffset) {
          return
        }

        let newOffset = currentOffset > containerSize
          ? currentOffset - containerSize
          : 0

        this.navOffset = newOffset
      },
      scrollNext() {
        let navSize = this.$refs.navRef['offsetWidth']
        let containerSize = this.$refs.tabsScrollRef['offsetWidth']
        const currentOffset = this.navOffset

        if (navSize - currentOffset <= containerSize) {
          return
        }

        let newOffset = navSize - currentOffset > containerSize * 2
          ? currentOffset + containerSize
          : (navSize - containerSize)

        this.navOffset = newOffset
      },
      scrollToActiveTab() {
        const nav = this.$refs.navRef
        const activeTab = this.$el.querySelector('.tabs-cur')
        if (!activeTab) {
          return
        }
        const navScroll = this.$refs.tabsScrollRef
        const activeTabBounding = activeTab.getBoundingClientRect()
        const navScrollBounding = navScroll.getBoundingClientRect()
        const navBounding = nav.getBoundingClientRect()
        const currentOffset = this.navOffset
        let newOffset = currentOffset

        if (activeTabBounding.left < navScrollBounding.left) {
          newOffset = currentOffset - (navScrollBounding.left - activeTabBounding.left)
        }
        if (activeTabBounding.right > navScrollBounding.right) {
          newOffset = currentOffset + activeTabBounding.right - navScrollBounding.right
        }
        if (navBounding.right < navScrollBounding.right) {
          newOffset = nav.offsetWidth - navScrollBounding.width
        }
        this.navOffset = Math.max(newOffset, 0)
      }
    },
    beforeDestroy() {
      if (this.$refs.navRef && this.update) {
        removeResizeListener(this.$refs.navRef, this.update)
      }
      if (this.$refs.tabsScrollRef && this.update) {
        removeResizeListener(this.$refs.tabsScrollRef, this.update)
      }
    },
    watch: {
      currentPageId: function () {
        this.$nextTick(_ => {
          this.scrollToActiveTab()
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/top-tabs/top-tabs.vue